import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { calculateWeek } from 'utils';

const initialState = {
  currentWeek: calculateWeek(),
} as const;

export const currentWeekSlice = createSlice({
  name: 'currentWeek',
  initialState,
  reducers: {
    setCurrentWeek(state, action: PayloadAction<Date[]>) {
      state.currentWeek = action.payload;
    },
  },
});
